const GlobalModal = target => {
  const $body = $('body')
  const $target = $body.find(target)
  const $modalContainer = $body.find('.global-modal__container')
  const $modalContent = $body.find('.global-modal__content')
  const ajaxMethod = 'query_modal_content'
  const $close = $body.find('.global-modal__close')
  let color

  const ajaxRequest = data => {
    $.ajax({
      // eslint-disable-next-line no-undef
      url: ajax_object.ajax_url,
      method: 'POST',
      data: data,
    }).done((response) => {
      const data = JSON.parse(response)
      $modalContainer.addClass('opened')
      $modalContainer.fadeIn(0)
      $modalContent.html(data.template)
      $modalContainer.scrollTop(0)
    })
  }

  const initGlobalModal = () => {
    // Ouverture modale
    $target.on('click', e => {
      e.preventDefault()
      const $el = $(e.currentTarget)
      const post_id = $el.data('post-id')
      color = $el.data('color')
      $modalContainer.addClass(color)
      $body.addClass('modal-opened')
      const data = {
        action: ajaxMethod,
        // eslint-disable-next-line no-undef
        security: ajax_object.ajax_nonce,
        post_id: post_id,
      }
      ajaxRequest(data)
    })
    //Fermeture modale
    $close.on('click', e => {
      e.preventDefault()
      $modalContainer.fadeOut(400, () => {
        $modalContainer.removeClass('opened')
        $modalContainer.removeClass(color)
        $body.removeClass('modal-opened')
        $modalContent.html('')
      })
    })
  }

  if ($target.length) {
    initGlobalModal()
  }
}

export default GlobalModal;



// WEBPACK FOOTER //
// ./scripts/components/GlobalModal.js